module.exports = __webpack_public_path__ + "static/media/developer.50739450.svg";